// Core
import React, { useState, useEffect } from "react";

//Redux
import { useDispatch } from "react-redux";
import { fetchMiningNewsletterList } from "../../../Redux/Slices/miningKgSlice";

//Import Scss
import "./styles.scss";

//Import Custom Components
import NormalTable from "Components/Common/Table";
import Pagination from "Components/Pagination";

const Newsletter = () => {
  const headerDetails = [
    { label: "S No", sortKey: false },
    {
      label: "Email",
      sortKey: true,
      singleClickFunc: () => {
        setSortOptions({
          sort_by: !sortOptions.sort_by,
          order_by: "email",
        });
      },
    },
    { label: "Description", sortKey: false },
    {
      label: "Subscribed On",
      sortKey: true,
      singleClickFunc: () => {
        setSortOptions({
          sort_by: !sortOptions.sort_by,
          order_by: "createdAt",
        });
      },
    },
  ];

  const dispatch = useDispatch();
  const [newsletterList, setNewsletterList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [sortOptions, setSortOptions] = useState({
    sort_by: false,
    order_by: "createdAt",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [searchEmail, setSearchEmail] = useState("");

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  useEffect(() => {
    setIsLoading(true);
    dispatch(
      fetchMiningNewsletterList({
        data: {
          page: currentPage,
          limit: "10",
          search: searchEmail,
          sort_by: sortOptions.sort_by ? "ASC" : "DESC",
          order_by: sortOptions.order_by,
        },
        callBack: (value) => {
          setNewsletterList(value?.data?.data_list || []);
          setTotalPages(value?.data?.pageMeta?.totalPages || 1);
          setTotalCount(value?.data?.pageMeta?.total || 0);
          setIsLoading(false);
        },
      })
    );
  }, [dispatch, currentPage, searchEmail, sortOptions]);

  return (
    <div className="newsletterContainer">
      <div className="newsletterHeader">
        <p></p>
        <div className="newsletterDatePicker">
          <p className="totalCount">
  Total count : {totalCount}
</p>
          <input
            type="text"
            placeholder="Search by email address"
            value={searchEmail}
            onChange={(e) => {
              setSearchEmail(e.target.value);
              setCurrentPage(1);
            }}
            className="searchInput"
          />
        </div>
      </div>
      <div className="newsletterTableContainer">
        <NormalTable headerDetails={headerDetails}>
          {newsletterList.length > 0
            ? newsletterList.map((list, index) => {
                return (
                  <tr className="border" key={list.id}>
                    <td style={{ paddingLeft: "18px" }}>
                      {(currentPage - 1) * 10 + (index + 1)}
                    </td>
                    <td>{list.email || "-"}</td>
                    <td>{list.description || "-"}</td>
                    <td>{formatDate(list.createdAt) || "-"}</td>
                  </tr>
                );
              })
            : " "}
        </NormalTable>
        {newsletterList.length > 0 ? (
          ""
        ) : (
          <p
            style={{
              textAlign: "center",
              fontFamily: "poppins",
              fontSize: "4vh",
              marginTop: "2vh",
            }}
          >
            {isLoading ? "Loading" : "No Data Found"}{" "}
          </p>
        )}
        {newsletterList.length > 0 ? (
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
          />
        ) : (
          " "
        )}
      </div>
    </div>
  );
};

export default Newsletter;
